import { render, staticRenderFns } from "./UnitHeader.vue?vue&type=template&id=0f77aff8&scoped=true"
import script from "./UnitHeader.vue?vue&type=script&lang=js"
export * from "./UnitHeader.vue?vue&type=script&lang=js"
import style0 from "./UnitHeader.vue?vue&type=style&index=0&id=0f77aff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f77aff8",
  null
  
)

export default component.exports